export default __webpack_public_path__ + "static/media/experience.2da836ba.png";